import React, { useState, useEffect } from "react";
import statistiquesFacebook from "./../../../../services/MarketingService/StatistiquesFacebook";
import publicationService from "./../../../../services/MarketingService/PublicationService";
import { useParams } from "react-router-dom";
function PublicationFacebook({id}) {
  const [data, setData] = useState({});
  const [photos, setPhotos] = useState([]);
  const [images, setImages] = useState([]);

  //statistiques
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  const [reactions, setReactions] = useState(0);
  const [comments, setcomments] = useState(0);
  const [insights, setInsights] = useState(0);
  const [shares, setShares] = useState(0);
  const [ageGenreFollowers, setAgeGenreFollowers] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        getLikesCountForPostPublication(),
        getCommentsCountForPost(),
        getSharesCountForPost(),
        getInsightsCountForPost(),
      ]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
      setLoading(false);
    }
  };

  // Afficher le nombre de reactions for post
  const getLikesCountForPostPublication = async () => {
    const response = await statistiquesFacebook.getLikesCountForPostPublication(
      id
    );
    setReactions(response.data.success);
  };

  // Afficher le nombre de comments for post
  const getCommentsCountForPost = async () => {
    const response = await statistiquesFacebook.getCommentsCountForPost(id);
    setcomments(response.data.success);
  };

  // Afficher le nombre de shares for post
  const getSharesCountForPost = async () => {
    const response = await statistiquesFacebook.getSharesCountForPost(id);
    setShares(response.data.success);
  };

  // Afficher le nombre de vu for post
  const getInsightsCountForPost = async () => {
    const response = await statistiquesFacebook.getInsightsCountForPost(id);
    setInsights(response.data.success);
  };

  const fetchData = async () => {
    try {
      const response = await publicationService.getPublicationByID(id);
      setData(response.data.success);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <>
      {/* Main content */}
      <section className="content">
        {/* Row */}
        <div className="row">
          <div className="col-lg-3 col-6">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i className="far fa-heart" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Reactions</span>
                <span className="info-box-number">{reactions}</span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                <span className="progress-description">{reactions}</span>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div className="info-box bg-secondary ">
              <span className="info-box-icon">
                <i className="far fa-newspaper" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Commentaires</span>
                <span className="info-box-number">{comments}</span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                <span className="progress-description">{comments}</span>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div className="info-box bg-secondary ">
              <span className="info-box-icon">
                <i className="far fa-eye" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Vu</span>
                <span className="info-box-number">{insights}</span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                <span className="progress-description">{insights}</span>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div className="info-box bg-secondary ">
              <span className="info-box-icon">
                <i className="fa fa-share"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Partage</span>
                <span className="info-box-number">{shares}</span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                <span className="progress-description">{shares}</span>
              </div>
            </div>
          </div>
        </div>
        {/*end of row*/}
      </section>
    </>
  );
}

export default PublicationFacebook;
